import { MarketDrivenShippingMigratedBanner } from 'features/market-driven-shipping-migrate-banner/MarketDrivenShippingMigratedBanner';
import DashBoardComponents from 'features/settings/components/ppoints/dashboard/DashboardComponents';
import PagePickupBird from 'layouts/page/PagePickupBird';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DashboardPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <PagePickupBird title={t('DASHBOARD.TITLE')} subtitle={t('DASHBOARD.SUBTITLE')}>
            <MarketDrivenShippingMigratedBanner />
            <DashBoardComponents />
        </PagePickupBird>
    );
};

export default DashboardPage;
